import React, { FC, useEffect, useState } from 'react';
import { PositionBookmarkListItemVO } from '@domain/vo/common/PositionBookmarkListItemVO';
import PositionList from '@components/phs/test/positionList';
import ArrayUtil from '@utils/array/util';

interface PositionProps {
  positions?: PositionBookmarkListItemVO[];
}

const Position: FC<PositionProps> = ({ positions }) => {
  const [positionList, setPositionList] = useState<PositionBookmarkListItemVO[]>([]);

  useEffect(() => {
    setPositionList(ArrayUtil.shuffleArray(positions || []));
  }, [positions]);

  return <PositionList positionList={positionList} />;
};

export default Position;
